import * as React from "react";
import Divider from 'material-ui/Divider';
import { Col, Row } from "react-bootstrap";


export default class DivisorConTexto extends React.Component<DivisorConTextoProps> {

    render() {
        const { texto } = this.props;

        return (
            <Row>
                <Col className={"linea-izq"} sm={1}>
                    <Divider />
                </Col>
                <Col className={"espacio-texto"} sm={1}>
                    <label >{texto}</label>
                </Col>
                <Col className={"linea-der"} sm={10}>
                    <Divider />
                </Col>
            </Row>
        );
    }

}

interface DivisorConTextoProps {
    texto: string
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_general/componentes/DivisorConTexto.tsx